<template>
  <div>
    <page-title title="Import problemen" icon="pe-7s-cloud-upload"></page-title>
    <b-row>
      <b-col>
        <metabase identifier="import_errors"></metabase>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue"
import Metabase from "@/components/Metabase.vue"

export default {
  name: "ImportErrors",
  components: {PageTitle,Metabase}
}
</script>

<style scoped>

</style>
